"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.Unread = exports.SquareShareLine = exports.SquareForward = exports.Plain3 = exports.Plain2 = exports.Plain = exports.PenNewSquare = exports.PenNewRound = exports.Pen2 = exports.Pen = exports.PaperclipRounded2 = exports.PaperclipRounded = exports.Paperclip2 = exports.Paperclip = exports.MultipleForwardRight = exports.MultipleForwardLeft = exports.Mailbox = exports.LetterUnread = exports.LetterOpened = exports.Letter = exports.InboxUnread = exports.InboxOut = exports.InboxLine = exports.InboxIn = exports.InboxArchive = exports.Inbox = exports.ForwardRight = exports.Dialog2 = exports.Dialog = exports.CheckRead = exports.ChatUnread = exports.ChatSquareLike = exports.ChatSquareCode = exports.ChatSquareCheck = exports.ChatSquareCall = exports.ChatSquareArrow = exports.ChatSquare = exports.ChatRoundVideo = exports.ChatRoundUnread = exports.ChatRoundMoney = exports.ChatRoundLine = exports.ChatRoundLike = exports.ChatRoundDots = exports.ChatRoundCheck = exports.ChatRoundCall = exports.ChatRound = exports.ChatLine = exports.ChatDots = void 0;
var ChatDots_1 = require("./ChatDots");
__createBinding(exports, ChatDots_1, "default", "ChatDots");
var ChatLine_1 = require("./ChatLine");
__createBinding(exports, ChatLine_1, "default", "ChatLine");
var ChatRound_1 = require("./ChatRound");
__createBinding(exports, ChatRound_1, "default", "ChatRound");
var ChatRoundCall_1 = require("./ChatRoundCall");
__createBinding(exports, ChatRoundCall_1, "default", "ChatRoundCall");
var ChatRoundCheck_1 = require("./ChatRoundCheck");
__createBinding(exports, ChatRoundCheck_1, "default", "ChatRoundCheck");
var ChatRoundDots_1 = require("./ChatRoundDots");
__createBinding(exports, ChatRoundDots_1, "default", "ChatRoundDots");
var ChatRoundLike_1 = require("./ChatRoundLike");
__createBinding(exports, ChatRoundLike_1, "default", "ChatRoundLike");
var ChatRoundLine_1 = require("./ChatRoundLine");
__createBinding(exports, ChatRoundLine_1, "default", "ChatRoundLine");
var ChatRoundMoney_1 = require("./ChatRoundMoney");
__createBinding(exports, ChatRoundMoney_1, "default", "ChatRoundMoney");
var ChatRoundUnread_1 = require("./ChatRoundUnread");
__createBinding(exports, ChatRoundUnread_1, "default", "ChatRoundUnread");
var ChatRoundVideo_1 = require("./ChatRoundVideo");
__createBinding(exports, ChatRoundVideo_1, "default", "ChatRoundVideo");
var ChatSquare_1 = require("./ChatSquare");
__createBinding(exports, ChatSquare_1, "default", "ChatSquare");
var ChatSquareArrow_1 = require("./ChatSquareArrow");
__createBinding(exports, ChatSquareArrow_1, "default", "ChatSquareArrow");
var ChatSquareCall_1 = require("./ChatSquareCall");
__createBinding(exports, ChatSquareCall_1, "default", "ChatSquareCall");
var ChatSquareCheck_1 = require("./ChatSquareCheck");
__createBinding(exports, ChatSquareCheck_1, "default", "ChatSquareCheck");
var ChatSquareCode_1 = require("./ChatSquareCode");
__createBinding(exports, ChatSquareCode_1, "default", "ChatSquareCode");
var ChatSquareLike_1 = require("./ChatSquareLike");
__createBinding(exports, ChatSquareLike_1, "default", "ChatSquareLike");
var ChatUnread_1 = require("./ChatUnread");
__createBinding(exports, ChatUnread_1, "default", "ChatUnread");
var CheckRead_1 = require("./CheckRead");
__createBinding(exports, CheckRead_1, "default", "CheckRead");
var Dialog_1 = require("./Dialog");
__createBinding(exports, Dialog_1, "default", "Dialog");
var Dialog2_1 = require("./Dialog2");
__createBinding(exports, Dialog2_1, "default", "Dialog2");
var ForwardRight_1 = require("./ForwardRight");
__createBinding(exports, ForwardRight_1, "default", "ForwardRight");
var Inbox_1 = require("./Inbox");
__createBinding(exports, Inbox_1, "default", "Inbox");
var InboxArchive_1 = require("./InboxArchive");
__createBinding(exports, InboxArchive_1, "default", "InboxArchive");
var InboxIn_1 = require("./InboxIn");
__createBinding(exports, InboxIn_1, "default", "InboxIn");
var InboxLine_1 = require("./InboxLine");
__createBinding(exports, InboxLine_1, "default", "InboxLine");
var InboxOut_1 = require("./InboxOut");
__createBinding(exports, InboxOut_1, "default", "InboxOut");
var InboxUnread_1 = require("./InboxUnread");
__createBinding(exports, InboxUnread_1, "default", "InboxUnread");
var Letter_1 = require("./Letter");
__createBinding(exports, Letter_1, "default", "Letter");
var LetterOpened_1 = require("./LetterOpened");
__createBinding(exports, LetterOpened_1, "default", "LetterOpened");
var LetterUnread_1 = require("./LetterUnread");
__createBinding(exports, LetterUnread_1, "default", "LetterUnread");
var Mailbox_1 = require("./Mailbox");
__createBinding(exports, Mailbox_1, "default", "Mailbox");
var MultipleForwardLeft_1 = require("./MultipleForwardLeft");
__createBinding(exports, MultipleForwardLeft_1, "default", "MultipleForwardLeft");
var MultipleForwardRight_1 = require("./MultipleForwardRight");
__createBinding(exports, MultipleForwardRight_1, "default", "MultipleForwardRight");
var Paperclip_1 = require("./Paperclip");
__createBinding(exports, Paperclip_1, "default", "Paperclip");
var Paperclip2_1 = require("./Paperclip2");
__createBinding(exports, Paperclip2_1, "default", "Paperclip2");
var PaperclipRounded_1 = require("./PaperclipRounded");
__createBinding(exports, PaperclipRounded_1, "default", "PaperclipRounded");
var PaperclipRounded2_1 = require("./PaperclipRounded2");
__createBinding(exports, PaperclipRounded2_1, "default", "PaperclipRounded2");
var Pen_1 = require("./Pen");
__createBinding(exports, Pen_1, "default", "Pen");
var Pen2_1 = require("./Pen2");
__createBinding(exports, Pen2_1, "default", "Pen2");
var PenNewRound_1 = require("./PenNewRound");
__createBinding(exports, PenNewRound_1, "default", "PenNewRound");
var PenNewSquare_1 = require("./PenNewSquare");
__createBinding(exports, PenNewSquare_1, "default", "PenNewSquare");
var Plain_1 = require("./Plain");
__createBinding(exports, Plain_1, "default", "Plain");
var Plain2_1 = require("./Plain2");
__createBinding(exports, Plain2_1, "default", "Plain2");
var Plain3_1 = require("./Plain3");
__createBinding(exports, Plain3_1, "default", "Plain3");
var SquareForward_1 = require("./SquareForward");
__createBinding(exports, SquareForward_1, "default", "SquareForward");
var SquareShareLine_1 = require("./SquareShareLine");
__createBinding(exports, SquareShareLine_1, "default", "SquareShareLine");
var Unread_1 = require("./Unread");
__createBinding(exports, Unread_1, "default", "Unread");
